import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { DatePipe } from "@angular/common";
import * as moment from "moment";
import { MatDialog } from "@angular/material/dialog";
import { AppConfig } from "../../app.config";
import { ModalComponent } from "../../modal/modal.component";
import { ApiService } from "../../services/jrni/api.service";
import { DepartmentService } from "../../services/jrni/department.service";
import { MemberService } from "../../services/jrni/member.service";
import { ServicesService } from "../../services/jrni/services.service";

@Component({
  selector: "app-upcoming-bookings",
  templateUrl: "./upcoming-bookings.component.html",
  styleUrls: ["./upcoming-bookings.component.scss"],
})
export class UpcomingBookingsComponent implements OnInit {
  bookings: any = [];
  member;
  private bookingQuestionsConfig = AppConfig.settings.bookingQuestions;

  constructor(
    private memberService: MemberService,
    private apiService: ApiService,
    private departmentService: DepartmentService,
    private servicesService: ServicesService,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private cdref: ChangeDetectorRef,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.getBookings();

    this.dialog.afterAllClosed.subscribe(() => {
      // console.log(`refreshing bookings`);
      // this.getBookings();
      this.cdref.markForCheck();
      this.scrollToTop();
    });
  }

  getBookings() {
    this.spinner.show();
    this.departmentService.getParentDepartment().then((parentCompany) => {
      this.memberService.getMember().then((member) => {
        this.member = member;
        this.memberService.getBookings().then((bookings) => {
          bookings = bookings.filter((booking) => {
            console.log(moment(booking.datetime.format('DD-MM-YYYY HH:mm:ss'), 'DD-MM-YYYY HH:mm:ss'))
            console.log(moment(booking.datetime.format('DD-MM-YYYY HH:mm:ss'), 'DD-MM-YYYY HH:mm:ss').isAfter(moment()))
            return moment(booking.datetime.format('DD-MM-YYYY HH:mm:ss'), 'DD-MM-YYYY HH:mm:ss').isAfter(moment())
          })
          console.log("bookings", bookings)
          // bookings = bookings._embedded.bookings;
          bookings = bookings.sort((a, b) => {
            return (
              new Date(a.datetime).getTime() - new Date(b.datetime).getTime()
            );
          });

          for (let booking of bookings) {
            booking.min_cancellation_time_moment = moment(booking.min_cancellation_time.format('DD-MM-YYYY HH:mm:ss'), 'DD-MM-YYYY HH:mm:ss')
          }

          this.bookings = bookings;
          console.log(this.bookings);
          this.spinner.hide();
        });
      });
    });
  }

  canCancel(booking) {
    return moment().isAfter(booking.min_cancellation_time_moment)
  }

  openCancelDialog(booking): void {
    this.departmentService
      .getDepartment(booking.company_id)
      .then((location) => {
        this.departmentService
          .getService(booking.company_id, booking.service_id)
          .then((service) => {
            const dialogRef = this.dialog.open(ModalComponent, {
              width: "800px",
              data: {
                header: this.translateService.instant(
                  "ACCOUNT.CANCEL_BOOKING_HEADER"
                ),
                action: "cancel",
                booking,
                service,
                member: this.member,
                location,
              },
            });

            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                this.bookings = this.bookings.filter((x) => {
                  console.log(
                    x.id.toString(),
                    result.id.toString(),
                    x.id.toString() !== result.id.toString()
                  );
                  return x.id.toString() !== result.id.toString();
                });
                console.log(" this.bookings", this.bookings);
              }
              // this.getBookings()
              this.cdref.detectChanges();
              this.scrollToTop();
            });
          });
      });
  }

  openModifyDialog(booking): void {
    this.spinner.show();
    this.departmentService
      .getDepartment(booking.company_id)
      .then((location) => {
        this.departmentService
          .getService(booking.company_id, booking.service_id)
          .then((service) => {
            const dialogRef = this.dialog.open(ModalComponent, {
              width: "1000px",
              data: {
                header: this.translateService.instant(
                  "ACCOUNT.MODIFY_BOOKING_HEADER"
                ),
                action: "modify",
                booking,
                service,
                location,
                member: this.member,
              },
            });

            dialogRef.afterClosed().subscribe((result) => {
              console.log("afterClosed() fired with:", result);
              if (result) {
                booking = result;
              }

              this.getBookings();

              this.cdref.detectChanges();
              this.scrollToTop();
              this.spinner.hide()
            });
          });
      });
  }

  openDetailsDialog(booking): void {
    this.spinner.show();
    this.departmentService
      .getDepartment(booking.company_id)
      .then((location) => {
        this.departmentService
          .getService(booking.company_id, booking.service_id)
          .then((service) => {
            // Add 0 to number if not there already
            // if (booking.questions[this.bookingQuestionsConfig.contactNumber].answer) {
            //   if (booking.questions[this.bookingQuestionsConfig.contactNumber].answer.toString().charAt(0) != "0") {
            //     booking.questions[this.bookingQuestionsConfig.contactNumber].answer = `0${booking.questions[this.bookingQuestionsConfig.contactNumber].answer}`;
            //   }
            // }

            // Change date format
            // if (booking.questions[this.bookingQuestionsConfig.dobID] && booking.questions[this.bookingQuestionsConfig.dobID].answer.includes('-')) {
            //   booking.questions[this.bookingQuestionsConfig.dobID].answer = new DatePipe('en-UK').transform(booking.questions[this.bookingQuestionsConfig.dobID].answer, 'dd/MM/yyyy');
            // }

            const dialogRef = this.dialog.open(ModalComponent, {
              width: "1000px",
              data: {
                header: this.translateService.instant(
                  "ACCOUNT.DETAILS_BOOKING_HEADER"
                ),
                action: "details",
                booking,
                service,
                location,
                member: this.member,
              },
            });
            dialogRef.afterClosed().subscribe((result) => {
              console.log("afterClosed() fired with:", result.answers);
              if (result) {
                booking = result;
              }

              // this.getBookings();
              // window.location.reload()

              // this.cdref.detectChanges();
              this.scrollToTop();
            });
            this.spinner.hide();
          });
      });
  }

  // Scroll to the top of the page
  scrollToTop() {
    window.scroll(0, 0);
  }
}
